import React from 'react';

export const getHandlerKayPress = (key: string, cb: () => void) => {
  return (e: React.KeyboardEvent) => {
    if (e.key === key) {
      cb();
    }
  };
};

export const handleEventPrevent = <T extends React.MouseEvent | React.KeyboardEvent>(e: T) => {
  e.preventDefault();
};
export const handleEventStop = <T extends React.MouseEvent | React.KeyboardEvent>(e: T) => {
  e.stopPropagation();
};
